/**
 * Converts a File or Blob to a raw base64 string (no data URL prefix).
 * @param {File|Blob} file
 * @returns {Promise<string>} Base64-encoded content
 */
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

/**
 * Converts a raw base64 string back to a File object.
 * @param {string} base64 - Raw base64 (no data URL prefix)
 * @param {string} name - Filename to assign
 * @returns {File}
 */
export const base64ToFile = (base64, name = "document.pdf") => {
  const byteString = atob(base64);
  const bytes = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }
  return new File([bytes], name, { type: "application/pdf" });
};
